import { GetStorage, SetStorage } from "../../data/protocols/cache";

export class LocalStorageAdapter implements SetStorage, GetStorage {
  set(key: string, value?: object): void {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.removeItem(key);
    }
  }

  get(key: string): any {
    const account = localStorage.getItem(key);
    if (account) return JSON.parse(account);
    return {};
  }
}
